import { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { RoutePath } from '@/section/router';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const tabs = [
  {
    label: "General Contracts",
    path: RoutePath.ContractsGeneralDashboard,
  },
  {
    label: "OTC Contracts",
    path: RoutePath.ContractsOtcDashboard,
  }
];

export function ContractsDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect to general contracts tab by default
  useEffect(() => {
    if (location.pathname === RoutePath.ContractsDashboard) {
      navigate(RoutePath.ContractsGeneralDashboard, { replace: true });
    }
  }, [location.pathname, navigate]);

  const isActiveTab = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="flex flex-col gap-4 overflow-hidden max-w-full h-full">
      {/* Header with page title buttons */}
      <div className="flex flex-row gap-2 items-center">
        {tabs.map((tab, index) => (
          <div key={tab.path} className="flex items-center">
            <Button
              variant="ghost"
              className={cn(
                "text-xl sm:text-2xl font-bold p-0 h-auto hover:bg-transparent",
                isActiveTab(tab.path)
                  ? "text-foreground"
                  : "text-muted-foreground hover:text-foreground"
              )}
              onClick={() => navigate(tab.path)}
            >
              {tab.label}
            </Button>
            {index < tabs.length - 1 && (
              <span className="text-xl sm:text-2xl font-bold text-muted-foreground mx-2">/</span>
            )}
          </div>
        ))}
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
}

